const { defaultLanguage, supportedLanguages } = require("./lang/constants");
const pl = require("./lang/pl");
const en = require("./lang/en");

module.exports = { pl, en, defaultLanguage, supportedLanguages };
